import { render, staticRenderFns } from "./IcoCircleOrbit.vue?vue&type=template&id=676e80f1"
import script from "./IcoCircleOrbit.vue?vue&type=script&lang=js"
export * from "./IcoCircleOrbit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports